import { ReactElement, useState } from 'react';
import { Component as UnsavedCartIcon } from 'icons/icon-circle-lime--unsaved-cart.svg';
import { Modal } from './Modal';
import { Button } from '../button/Button';
import { useMenuWithCart } from '../../../contexts/MenuWithCart';
import styles from './Modal.module.scss';

export enum AlertModalVariant {
  CART_BELOW_MINIMUM = 'cart_below_minimum',
}

interface Props {
  variant: AlertModalVariant,
  isOpen: boolean;
  onClose: (closeBySave?: boolean) => void;
  onClick: () => void;
}

export function AlertModal({
  variant,
  isOpen,
  onClose,
  onClick,
}: Props): ReactElement {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);
  const {
    setIsCartDrawerOpen,
    cart,
    saveCart,
    discardCartChanges,
  } = useMenuWithCart();

  const closeAll = (closeBySave = false) => {
    setIsModalOpen(false);
    onClose(closeBySave);
  };

  const returnToCart = () => {
    setIsCartDrawerOpen(true);
    closeAll();
  };

  const discardAndClose = () => {
    discardCartChanges();
    onClick();
    closeAll(true);
  };

  const modalContent = {
    [AlertModalVariant.CART_BELOW_MINIMUM]: {
      modalText: `${cart?.priceSummary?.minimumBasePrice} minimum order. Add ${cart?.priceSummary?.remainingMinimumAmount} to cart.`,
      primaryButtonText: 'Discard Changes',
      primaryButtonAction: discardAndClose,
    },
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={closeAll}
      title={(
        <div className={styles.alert_modal_title}>
          <UnsavedCartIcon />
          <div className={styles.alert_modal_title_text}>
            {modalContent[variant].modalText}
          </div>
        </div>
      )}
      classNames={{
        modal: styles.alert_modal_content,
        header: styles.alert_modal_header,
        close: styles.close_button,
      }}
    >
      <div className={styles.alert_modal_actions}>
        <Button
          text="Return to Cart"
          style={{
            background: '#FFF',
            color: '#212529',
            border: '1px solid #DEE2E6',
            width: 'auto',
            whiteSpace: 'nowrap',
            fontFamily: 'Roboto',
          }}
          onClick={returnToCart}
        />
        <Button
          text={modalContent[variant].primaryButtonText}
          style={{
            width: 'auto',
            whiteSpace: 'nowrap',
            fontFamily: 'Roboto',
          }}
          onClick={modalContent[variant].primaryButtonAction}
        />
      </div>
    </Modal>
  );
}
